import { defineMessages } from 'react-intl';

const _default_1: {
	genericErrorDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	genericErrorHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	genericErrorHeading: {
		id: 'company-hub.generic-error-page.heading',
		defaultMessage: "We're on it",
		description:
			'The text is shown as the main heading on the generic error page displayed when an unexpected error occurs in a Company Hub page, reassuring users that the issue is being addressed.',
	},
	genericErrorDescription: {
		id: 'company-hub.generic-error-page.description',
		defaultMessage:
			'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
		description:
			'The text is shown as the body paragraph on the generic error page in Company Hub, explaining to users that an unexpected error occurred and the team is working to restore functionality.',
	},
});
export default _default_1;
